import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_SIGNALS } from "app/pages/sales-intelligence/constants/routes";
import SignalsCardEmpty from "app/pages/sales-intelligence/pages/company-analysis/components/cards/signals-card/SignalsCardEmpty/SignalsCardEmpty";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";

import SignalsCardTracked from "./SignalsCardTracked";

const SignalsCardWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="signals-card"
        header={<CardHeader title={translate("si.company-analysis.signals.card.header")} />}
        footer={
            <CardFooter
                stateId={COMPANY_ANALYSIS_SIGNALS}
                linkText="si.company-analysis.signals.card.full_report"
            />
        }
        width="50%"
        fallbackContent={<SignalsCardEmpty />}
    >
        <SignalsCardTracked />
    </CardErrorBoundary>
);

export default SignalsCardWithErrorBoundary;
